import React, { Component } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'
import PaddedPaper from './PaddedPaper'

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    maxWidth: 1200,
  },
}))

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, info)
  }

  render() {
    if (this.state.hasError) {
      return <DefaultError />
    }

    return this.props.children
  }
}

const DefaultError = () => {
  const classes = useStyles()

  return (
    <PaddedPaper className={classes.root} padSpacing={3}>
      <Typography variant="h6" color="error">
        An issue has occurred. Please refresh the page and try again. If the problem continues to
        occur, please contact support.
      </Typography>
    </PaddedPaper>
  )
}
